/// <reference path="../../app.ts" />
/// <reference path="../subcataccordion.ts" />
/// <reference path="../isubcataccordion.ts" />
module Cfnc
{
    "use strict";

    export class AdditionalServices extends SubCatAccordion implements IsubCatAccordion
    {
        typeCbs = [{ type: "Daycare", isChecked: false },
            { type: "Alcohol/Substance Abuse Counseling", isChecked: false },
            { type: "Personal/psychological Counseling", isChecked: false },
            { type: "Health Services", isChecked: false },
            { type: "Learning Assistance Services", isChecked: false },
            { type: "Work-Study", isChecked: false }
        ];

        public getSelectedTypes(): Array<string>
        {
            var selectedTypes = new Array<string>();
            this.selected = false;
            for ( var i in this.typeCbs )
            {
                if ( this.typeCbs[i].isChecked )
                {
                    selectedTypes.push( this.typeCbs[i].type );
                    this.selected = true;
                }
            }
            return selectedTypes;
        }
    }
}